export default __webpack_public_path__ + "81b212cb96ed1768927a3200d416eb5d.png";